<template>
  <div>
    <h1 class="page_title">成员管理</h1>
    <div class="filter-container">
      <!-- <el-input size="small" class="filter-item" style="width: 200px;" placeholder="姓名/拼音手机号" v-model="searchKey"></el-input> -->
      <!-- <el-button size="small" class="filter-item">搜索</el-button> -->
      <el-button size="small" class="filter-item" @click="list" icon="el-icon-refresh"></el-button>
      <el-button size="small" class="filter-item" @click="showVerifyDialog">添加成员</el-button>
    </div>
    <el-table :data="tableRecords" stripe>
      <el-table-column align="left" label="姓名" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.userName + " - " + scope.row.mobile }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="角色" width="150">
        <template slot-scope="scope">
          <span>{{ $common.getRoleName(scope.row.role) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="加入时间" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | parseTime("{y}年{m}月{d}日") }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="销服账号" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.siebelId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="激活" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.userIsActive ? "已激活" : "未激活" }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="状态" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.status | statusDisplay }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="mini" v-show="scope.row.role != 15 && scope.row.role != 16"
            @click="showEditDialog(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.memberId != user.id &&
            scope.row.role != 15 &&
            scope.row.role != 16
            " type="warning" size="mini" @click="showLeaveDialog(scope.row)">离职</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="修改成员" :visible.sync="editDialog" width="700px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <div class="boxs">
        <div class="box1">
          <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-position="right" label-width="120px">
            <el-form-item class="form_item" label="姓名">{{
              editForm.userName
            }}</el-form-item>
            <el-form-item class="form_item" label="身份证号">{{
              editForm.userIdentifyNo
            }}</el-form-item>
            <el-form-item class="form_item_val" label="手机号" prop="mobile">
              <el-input size="small" style="width: 200px;" v-model="editForm.mobile"></el-input>
            </el-form-item>
            <el-form-item class="form_item_val" label="销服账号" :class="{ mb0: isAll }">
              <el-select style="width: 200px;" class="filter-item" v-model="editForm.siebelId" size="small">
                <el-option v-for="(item, c) in siebelIds" :key="c" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <span v-if="isAll" class="isAll">该成员无销服账号，请手动匹配店端销服账号</span>
            <el-form-item class="form_item_val" label="角色">
              <el-select style="width: 160px" class="filter-item" v-model="editForm.role" @change="editRoleChange"
                v-if="editForm.role != 11" size="small">
                <el-option v-for="(item, d) in roleOptions" :key="d"
                  :disabled="item.dataValue === 15 || item.dataValue === 16" :label="item.dataDisplay"
                  :value="item.dataValue">
                </el-option>
              </el-select>
              <span v-else>投资人</span>
            </el-form-item>
            <el-form-item class="form_item_val" label="直属上级">
              <el-select style="width: 160px" class="filter-item" v-model="edittopUserId" @change="editChange"
                size="small">
                <el-option v-for="(item, o) in EdittopUserOptions" :key="o" :label="item.userName"
                  :value="item.memberId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="form_item_val" label="直属下级" width="400px">
              <div style="width: 300px">
                <el-checkbox-group v-model="editForm2.downUserIds">
                  <el-checkbox v-for="(item, g) in EditdownUserIds" :label="item.memberId" :key="g"
                    v-show="item.memberId !== edittopUserId">{{ item.userName }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="modules">
          <el-tree :data="modules2" v-if="editDialog" ref="tree" show-checkbox default-expand-all node-key="identify"
            :check-on-click-node="false" :expand-on-click-node="false" @check="nodeClick" :props="defaultProps" check-strictly>
          </el-tree>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="saveLoading" @click="doSave" type="text">保存</el-button>
        <el-button @click="editDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="身份验证" :visible.sync="verifyDialog" width="350px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="verifyForm" :model="newForm" :rules="newFormRules" label-position="right" label-width="100px">
        <el-form-item class="form_item_val" label="姓名" prop="name">
          <el-input size="small" style="width: 200px;" v-model.trim="newForm.name"></el-input>
        </el-form-item>
        <el-form-item class="form_item_val" label="手机号" prop="phone">
          <el-input size="small" style="width: 200px;" v-model.trim="newForm.phone"></el-input>
        </el-form-item>
        <el-form-item class="form_item_val" label="身份证号码" prop="idno">
          <el-input size="small" style="width: 200px;" v-model.trim="newForm.idno"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doVerify" type="text">下一步</el-button>
        <el-button @click="verifyDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="添加成员" :visible.sync="newDialog" width="700px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <div class="boxs">
        <div class="box1">
          <el-form ref="newForm" :model="newForm" :rules="newFormRules" label-position="right" label-width="120px">
            <el-form-item class="form_item" label="姓名">{{
              newForm.name
            }}</el-form-item>
            <el-form-item class="form_item" label="手机号">{{
              newForm.phone
            }}</el-form-item>
            <el-form-item class="form_item" label="身份证号">{{
              newForm.idno
            }}</el-form-item>
            <el-form-item class="form_item_val" label="销服账号" :class="{ mb0: isAll }">
              <el-select style="width: 200px" class="filter-item" v-model="newForm.siebelId" size="small">
                <el-option v-for="item in siebelIds" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <span v-if="isAll" class="isAll">该成员无销服账号，请手动匹配店端销服账号</span>
            <el-form-item class="form_item_val" label="角色">
              <el-select style="width: 160px" class="filter-item" v-model="newForm.role" @change="newRoleChange"
                size="small" v-if="newForm.role != 11">
                <el-option v-for="item in roleOptions" :key="item.dataValue" :label="item.dataDisplay"
                  :value="item.dataValue" :disabled="item.dataValue === 15 || item.dataValue === 16"></el-option>
              </el-select>
              <span v-else>投资人</span>
            </el-form-item>
            <el-form-item class="form_item_val" label="直属上级">
              <el-select style="width: 160px" class="filter-item" v-model="newForm.topUserId" @change="newChange"
                size="small">
                <el-option v-for="item in topUserOptions" :key="item.memberId" :label="item.userName"
                  :value="item.memberId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="form_item_val" label="直属下级" width="400px">
              <div style="width: 300px">
                <el-checkbox-group v-model="newForm.downUserIds">
                  <el-checkbox v-for="item in downUserIds" :label="item.memberId" :key="item.memberId"
                    v-show="item.memberId !== newForm.topUserId">{{ item.userName }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="modules">
          <el-tree v-if="newDialog" :data="modules2" ref="tree" show-checkbox default-expand-all node-key="identify"
            :check-on-click-node="false" :expand-on-click-node="false" @check="nodeClick" :props="defaultProps" check-strictly>
          </el-tree>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doAdd" type="text">保存</el-button>
        <el-button @click="newDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="'离职 - ' + choosedName" :visible.sync="leaveDialog" width="350px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <div>
        <div style="font-size:12px;font-weight:400;">
          1.员工离职需要将他的客户数据转移，请分配客户经理
        </div>
        <div style="margin-bottom:10px;font-size:12px;font-weight:400;">
          2.员工离职需对其组织架构中的下属进行转移
        </div>
        <el-form ref="deForm" :model="deForm" label-position="right" label-width="120px">
          <el-form-item class="form_item_val" label="跟进客户经理">
            <el-select style="width: 150px" class="filter-item" v-model="deForm.leaveToMemberId" size="small">
              <el-option v-for="item in controlUsers" :key="item.memberId" :label="item.userName"
                :value="item.memberId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form_item_val" label="组织架构下属转移">
            <el-select style="width: 150px" class="filter-item" v-model="deForm.topUserId" size="small">
              <el-option v-for="item in controlUsers" :key="item.memberId" :label="item.userName"
                :value="item.memberId"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doLeave" type="text">确认离职</el-button>
        <el-button @click="leaveDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dealer: this.$common.getDealer(),
      user: this.$common.getUser(),
      listQuery: {
        searchKey: "",
      },
      tableRecords: [],
      saveLoading: false,
      editDialog: false,
      editForm: {},
      editFormRules: {
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
      },

      roleOptions: [],

      verifyDialog: false,
      newForm: {
        name: "",
        phone: "",
        idno: "",
        role: 4,
        siebelId: "",
      },

      siebelIds: [],

      newFormRules: {
        name: [
          {
            required: true,
            message: "请输入成员姓名",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        idno: [
          {
            required: true,
            message: "请输入身份证号码",
            trigger: "blur",
          },
        ],
      },

      newDialog: false,

      controlDialog: false,
      controlUsers: [],
      controlManagerId: 0,
      controlIds: [],

      leaveDialog: false,
      leaveMemberId: 0,
      leaveToMemberId: "",

      choosedName: "",

      chooseSeibelDialog: false,
      topUserOptions: [], //上级数组
      EdittopUserOptions: [], // 编辑时的上级数组
      EditdownUserIds: [], // 编辑时的下级数组
      downUserIds: [], //下级数组
      modules: [], // 模块数组
      value: "",
      defaultProps: {
        children: "nodes",
        label: "name",
      },
      selectedModules: [],
      editForm2: {
        downUserIds: [],
      },
      edittopUserId: "",
      deForm: {}, // 离职表单
      decontrolUsers: [], // 离职时可选择的上级
      newArr: [],
      newArr2: [],
      isAll: false,
      axiosTimes: 0,
      modules2: [],
      cityPoolEnable: false,
    };
  },
  filters: {
    statusDisplay(status) {
      const statusMap = {
        0: "正常",
        "-1": "冻结",
      };
      return statusMap[status];
    },
  },
  mounted() {
    this.list();
    var baseInfo = this.$common.getBaseInfo();
    var loginInfo = this.$common.getLoginInfo();
    this.roleOptions = baseInfo.dealerMemberRoles.filter(
      (item) => item.dataValue != 11 && item.dataValue != 17
    );
    this.modules = loginInfo.modules;
    this.modules2 = loginInfo.modules;
    this.cityPoolEnable = loginInfo.cityPoolEnable;
  },
  methods: {
    // 编辑时角色改变
    editRoleChange(value) {
      var defaultModules = [];
      this.roleOptions.forEach((item) => {
        if (item.dataValue == value) {
          defaultModules = item.remark.split(",");
        }
      });
      this.modules2 = this.modules;
      // if (value != 5) {
      //   this.modules2 = this.modules.filter(item => item.name != '品牌线索池');
      // } else {
      //   if (this.cityPoolEnable) {
      //     this.modules2 = this.modules;
      //   } else {
      //     this.modules2 = this.modules.filter(item => item.name != '品牌线索池');
      //   }
      // }
      
      // 先置空选择 后循环勾选   （setCheckedKeys(defaultModules)会在勾选父节点时自动勾选子节点，不符合要求）
      this.$refs.tree.setCheckedKeys([])
      defaultModules.forEach(t => {
        this.$refs.tree.setChecked(t, true)
      })

      this.selectedModules = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys());
    },
    // 添加时角色改变
    newRoleChange(value) {
      var defaultModules = [];
      this.roleOptions.forEach((item) => {
        if (item.dataValue == value) {
          defaultModules = item.remark.split(",");
        }
      });
      this.modules2 = this.modules;
      // if (value != 5) {
      //   this.modules2 = this.modules.filter(item => item.name != '品牌线索池');
      // } else {
      //   if (this.cityPoolEnable) {
      //     this.modules2 = this.modules;
      //   } else {
      //     this.modules2 = this.modules.filter(item => item.name != '品牌线索池');
      //   }
      // }
      // 先置空选择 后循环勾选   （setCheckedKeys(defaultModules)会在勾选父节点时自动勾选子节点，不符合要求）
      this.$refs.tree.setCheckedKeys([])
      defaultModules.forEach(t => {
        this.$refs.tree.setChecked(t, true)
      })
      this.selectedModules = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys());
    },
    // 添加时直属上级选择改变事件
    newChange() {
      this.downUserIds = JSON.parse(JSON.stringify(this.newArr2));
      this.filterToUsers(this.newForm.topUserId);
      this.newForm.downUserIds = [];
    },
    // 编辑时直属上级选择改变事件
    editChange() {
      this.EditdownUserIds = JSON.parse(JSON.stringify(this.newArr));
      this.filterToUsers(this.edittopUserId);
      this.editForm2.downUserIds = [];
    },
    nodeClick(data, data1) {
      var that = this;
      setTimeout(() => {
        that.selectedModules = that.$refs.tree
          .getCheckedKeys()
          .concat(that.$refs.tree.getHalfCheckedKeys());
      }, 0);
    },
    // childNodesChange(node) {
    //   let len = node.childNodes.length;
    //   for (let i = 0; i < len; i++) {
    //     node.childNodes[i].checked = false;
    //     this.childNodesChange(node.childNodes[i]);
    //   }
    // },
    // parentNodesChange(node) {
    //   if (node.parent) {
    //     for (let key in node) {
    //       if (key == "parent") {
    //         node[key].checked = true;
    //         this.parentNodesChange(node[key]);
    //       }
    //     }
    //   }
    // },
    list() {
      var parent = this;
      this.$httpAuth
        .post("/v2/appDealerManagerService/memberList", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.tableRecords = response.data.data;
          parent.topUserOptions = response.data.data;
          parent.downUserIds = response.data.data;
          parent.newArr2 = JSON.parse(JSON.stringify(parent.downUserIds));
        })
        .catch(() => { });
    },
    showEditDialog(row) {
      this.EdittopUserOptions = [];
      this.EditdownUserIds = [];
      this.editForm2.downUserIds = [];
      this.edittopUserId = "";
      this.editForm = JSON.parse(JSON.stringify(row));
      if (this.$refs["editForm"]) {
        this.$refs["editForm"].resetFields();
      }
      this.topUserOptions.forEach((item) => {
        if (item.memberId !== row.memberId) {
          this.EdittopUserOptions.push(item);
        }
      });
      this.downUserIds.forEach((item) => {
        if (item.memberId !== row.memberId) {
          this.EditdownUserIds.push(item);
        }
      });
      this.newArr = JSON.parse(JSON.stringify(this.EditdownUserIds));
      row.members.forEach((item) => {
        this.editForm2.downUserIds.push(item.memberId);
      });
      if (this.editForm.manager !== null) {
        this.edittopUserId = this.editForm.manager.memberId;
      }
      this.filterToUsers(this.edittopUserId);
      // if (row.role != 5) {
      //   this.modules2 = this.modules.filter(item => item.name != '品牌线索池');
      // } else {
      //   if (this.cityPoolEnable) {
      //     this.modules2 = this.modules;
      //   } else {
      //     this.modules2 = this.modules.filter(item => item.name != '品牌线索池');
      //   }
      // }
      this.modules2 = this.modules;
      const loading = this.$loading({
        lock: true,
        text: "",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      var parent = this;
      this.$httpAuth
        .post("/v1/dealerMemberRpc/getSiebelIds", {
          dealerId: this.dealer.dealerId,
          memberId: this.editForm.memberId,
        })
        .then(function (response) {
          loading.close();
          parent.siebelIds = response.data.siebelIds;
          parent.isAll = response.data.isAll;
          parent.siebelIds.forEach((item) => {
            if (item.indexOf(parent.editForm.siebelId) >= 0) {
              parent.editForm.siebelId = item;
            }
          });
          parent.editDialog = true;
          setTimeout(() => {
            var nodes = [];
            if (row.modules.indexOf(",") !== -1) {
              row.modules.split(",").forEach((item) => {
                nodes.push(item);
                nodes.forEach((t) => {
                  parent.$refs.tree.setChecked(t, true);
                });
                // parent.$refs.tree.setCheckedKeys(nodes);
              });
            } else if (row.modules.indexOf(",") === -1 && row.modules) {
              // nodes.push(row.modules);
              parent.$refs.tree.setChecked(row.modules, true);
            }
            parent.selectedModules = parent.$refs.tree
              .getCheckedKeys()
              .concat(parent.$refs.tree.getHalfCheckedKeys());
          }, 100);
        })
        .catch(() => {
          loading.close();
        });
    },
    filterToUsers(id) {
      if (id !== "") {
        this.EditdownUserIds.forEach((item) => {
          if (id == item.memberId) {
            this.EditdownUserIds.splice(this.EditdownUserIds.indexOf(item), 1);
            if (item.manager !== null) {
              this.filterToUsers(item.manager.memberId);
            }
          }
        });
      }
    },
    filterNewToUsers(id) {
      if (id !== "") {
        this.downUserIds.forEach((item) => {
          if (id == item.memberId) {
            this.downUserIds.splice(this.downUserIds.indexOf(item), 1);
            if (item.manager !== null) {
              this.filterNewToUsers(item.manager.memberId);
            }
          }
        });
      }
    },
    doSave() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          if (this.saveLoading) return
          this.saveLoading = true
          if (this.editForm.role == 7) {
            this.editForm.handleFront = true;
          }
          this.$httpAuth
            .post("/v2/appDealerManagerService/memberUpdate", {
              dealerId: this.dealer.dealerId,
              memberId: this.editForm.memberId,
              name: this.editForm.userName,
              mobile: this.editForm.mobile,
              role: this.editForm.role,
              siebelId: this.editForm.siebelId.split("/")[0],
              siebelPosition: this.editForm.siebelId.split("/")[1],
              modules: this.selectedModules.join(","),
              topUserId: String(this.edittopUserId),
              downUserIds: this.editForm2.downUserIds
                .sort((a, b) => {
                  return a - b;
                })
                .join(","),
            })
            .then(()=> {
              this.editDialog = false;
              this.list();
              this.$message({
                message: "保存成功",
                type: "success",
              });
            }).finally(() => {
              this.saveLoading = false
            })
        }
      });
    },
    showVerifyDialog() {
      this.newForm = {
        name: "",
        phone: "",
        idno: "",
        role: 4,
        siebelId: "",
        topUserId: "",
        downUserIds: [],
      };
      if (this.$refs["verifyForm"]) {
        this.$refs["verifyForm"].resetFields();
      }
      this.verifyDialog = true;
    },
    // 下一步
    doVerify() {
      this.$refs["verifyForm"].validate((valid) => {
        if (valid) {
          var parent = this;
          this.$httpAuth
            .post("/v2/appDealerManagerService/memberVerify", {
              dealerId: this.dealer.dealerId,
              name: this.newForm.name.replace(/\s*/g, ""),
              mobile: this.newForm.phone.replace(/\s*/g, ""),
              identifyNo: this.newForm.idno.replace(/\s*/g, ""),
            })
            .then(function (res) {
              parent.newDialog = true;
              parent.verifyDialog = false;
              parent.isAll = res.data.isAll;
              parent.siebelIds = res.data.siebelIds.split(",");
              parent.newForm.siebelId = res.data.siebelIds.split(",")[0];
              // parent.newForm.topUserId =
              //     parent.topUserOptions[0].memberId;
              // parent.newChange();
              parent.selectedModules = [];
              parent.newForm.role = parent.roleOptions[0].dataValue;
              setTimeout(() => {
                parent.newRoleChange(parent.newForm.role);
              }, 0);
            })
            .catch(() => { });
        }
      });
    },
    doChooseSeibelId() {
      if (this.newForm.siebelId == "") {
        this.$message.error("请选择销服账号");
        return;
      }
      this.newDialog = true;
      this.chooseSeibelDialog = false;
    },
    // 添加成员
    doAdd() {
      if (new Date().getTime() / 1000 - this.axiosTimes < 2) {
        return;
      }
      this.axiosTimes = new Date().getTime() / 1000;
      var parent = this;
      this.$httpAuth
        .post("/v2/appDealerManagerService/memberAdd", {
          dealerId: this.dealer.dealerId,
          name: this.newForm.name,
          mobile: this.newForm.phone,
          identifyNo: this.newForm.idno,
          role: this.newForm.role,
          siebelId: this.newForm.siebelId.split("/")[0],
          siebelPosition: this.newForm.siebelId.split("/")[1],
          modules: this.selectedModules.join(","),
          topUserId: String(this.newForm.topUserId),
          downUserIds: this.newForm.downUserIds
            .sort((a, b) => {
              return a - b;
            })
            .join(","),
        })
        .then(function () {
          parent.newDialog = false;
          parent.list();
          parent.$message({
            message: "添加成功",
            type: "success",
          });
        })
        .catch(() => { });
    },
    showControlDialog(row) {
      this.controlManagerId = row.memberId;
      this.choosedName = row.userName;
      this.controlIds = [];
      var parent = this;
      var dataStrArr = row.controlIds.split(",");
      dataStrArr.forEach(function (data) {
        parent.controlIds.push(+data);
      });
      this.controlDialog = true;

      this.controlUsers = [];
      for (var i = 0; i < this.tableRecords.length; i++) {
        var o = this.tableRecords[i];
        if (o.memberId != row.memberId) {
          this.controlUsers.push(o);
        }
      }
    },
    showLeaveDialog(row) {
      this.choosedName = row.userName;
      this.leaveMemberId = row.memberId;
      this.deForm = {
        leaveToMemberId: "",
        topUserId: "",
      };
      this.leaveDialog = true;
      this.controlUsers = [];
      for (var i = 0; i < this.tableRecords.length; i++) {
        var o = this.tableRecords[i];
        if (o.memberId != row.memberId) {
          this.controlUsers.push(o);
        }
      }
      this.decontrolUsers = [...this.controlUsers];
      row.members.forEach((item) => {
        this.decontrolUsers.forEach((a) => {
          if (item.memberId === a.memberId) {
            this.decontrolUsers.splice(this.decontrolUsers.indexOf(item), 1);
          }
        });
      });
    },
    doLeave() {
      if (this.deForm.leaveToMemberId == "") {
        this.$message.error("请选择待分配成员");
        return;
      }
      if (this.deForm.topUserId == "") {
        this.$message.error("请选择组织架构转移");
        return;
      }
      var parent = this;
      this.$httpAuth
        .post("/v2/appDealerManagerService/memberLeave", {
          dealerId: this.dealer.dealerId,
          memberId: this.leaveMemberId,
          newMemberId: this.deForm.leaveToMemberId,
          newTopUserId: this.deForm.topUserId,
        })
        .then(function () {
          parent.leaveDialog = false;
          parent.list();
          parent.$message({
            message: "成员离职成功",
            type: "success",
          });
        })
        .catch(() => { });
    },
  },
};
</script>
<style>
.boxs {
  display: flex;
}

.modules {
  width: 240px;
  height: 260px;
  overflow-y: auto;
}

/* .el-tree {
  background: none;
}
.el-tree-node__label {
  position: relative;
}
.el-tree-node__label:before {
  content: "";
  width: 20px;
  height: 20px;
  display: block;
  position: absolute;
  top: 0px;
  left: -24px;
  z-index: 999;
}
.el-checkbox__inner {
  top: 0;
} */
.isAll {
  display: flex;
  color: red;
  font-size: 12px;
  text-indent: 120px;
}

.mb0 {
  margin-bottom: 0 !important;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
